export const APP_LOCALES = ["nl", "en", "en-gb", "de", "fr", "es", "it", "da", "sv"] as const;

export type AppLocale = (typeof APP_LOCALES)[number];

export function isAppLocale(input: unknown): input is AppLocale {
  return typeof input === "string" && (APP_LOCALES as readonly string[]).includes(input.toLowerCase());
}

export function normalizeAppLocale(input: unknown, fallback: AppLocale = "en"): AppLocale {
  if (isAppLocale(input)) return input.toLowerCase() as AppLocale;
  return fallback;
}
